export const ACCESS_TOKEN = 'access-token'
export const SET_TOKEN = 'set_token'
export const SET_ROUTE_TAB = 'set_route_tab'
export const ADD_ROUTE_TAB = 'add_route_tab'
export const DEL_ROUTE_TAB = 'del_route_tab'
export const ROUTE_TABS = 'route-tabs'
